const SUPPORT_URL = 'https://support.buffer.com'

/**
 * Opens the Help Scout Beacon so someone can reach a person, falling back to
 * the help centre when the Beacon script has not loaded.
 *
 * Deliberately does not point at the floating "?" button: HelpWidget renders
 * nothing until Brainfish is ready, and nothing at all once the
 * `move-beacon-to-help-menu` split is on, so copy referring to it would send
 * people looking for a control that is not on screen.
 */
export function openSupport(): void {
  if (window.Beacon) {
    window.Beacon('open')
    return
  }

  window.open(SUPPORT_URL, '_blank', 'noopener')
}
